import { render, staticRenderFns } from "./CalendarList.vue?vue&type=template&id=438ce2b4&scoped=true&"
import script from "./CalendarList.vue?vue&type=script&lang=js&"
export * from "./CalendarList.vue?vue&type=script&lang=js&"
import style0 from "./CalendarList.vue?vue&type=style&index=0&id=438ce2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438ce2b4",
  null
  
)

export default component.exports